import { setCookie } from './utils';

export default {
  storeExternalReferrer: function () {
    if (document.referrer.search(window.location.origin) == -1) {
      // Overwrite cookie if referrer contains a non-dashboard URL
      setCookie('dashboard_external_referrer', document.referrer, 2);
    }
  },
};
